import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { Input } from "@revvsales/components";
import {
  RevvForm,
  CustomSelect,
  ErrorMessages,
} from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";
import { PeriodOptions } from "../../../../constants/customDynamicMeta";
// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class PeriodField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      periodFieldValues: this._getDataForPrepopulate(props),
    };
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (
      propsData.meta &&
      propsData.meta.default &&
      propsData.meta.default.periodValue !== ""
    ) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.PERIOD),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = {
        options: this._prepareOptions(propsData.meta.options),
        periodValue: propsData.meta.default.periodValue,
        periodUom: this._prepareOptionsForrateUom(
          propsData.meta.default.periodUom,
        ),
      };
    }
    return returnData;
  };

  _prepareOptionsForrateUom = data => {
    let returnData = {};
    if (data) {
      returnData = { name: data, id: data };
    }
    return returnData;
  };

  _prepareOptions = data => {
    const returnData = [];
    if (data && data.length > 0) {
      data.forEach(element => {
        returnData.push({ name: element, id: element });
      });
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
  };

  resetState = () => {
    this.props.setFlagForDefault(true);
    this.props.metaValidStatus(false);
    const { showDefaultValue } = this.state;
    if (showDefaultValue === true) {
      this.setState({ showDefaultValue: false });
    }
  };

  _handleOrder = options => options.sort((a, b) => a.id - b.id);

  render() {
    const { showDefaultValue, periodFieldValues } = this.state;
    return (
      <React.Fragment>
        <RevvForm
          initialFormValue={periodFieldValues}
          customFieldName="RATE"
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          validateOnChange={false}
          render={formProps => {
            const {
              handleChange,
              // handleBlur,
              handleChangeByName,
              messages,
              values,
            } = formProps;
            if (values.options && values.options.length > 0) {
              values.options = this._handleOrder(values.options);
            }
            if (values.options.length === 0) {
              this.resetState();
            }
            if (
              !showDefaultValue &&
              (values.periodUom !== undefined || values.periodValue !== "")
            ) {
              values.periodUom = "";
              values.periodValue = "";
            }
            const options = [];
            for (let d = 0; d < values.options.length; d += 1) {
              options.push(values.options[d].name);
            }
            const data = {
              options,
              default: {
                periodValue: values.periodValue,
                periodUom:
                  values.periodUom !== undefined &&
                  values.periodUom.name !== undefined
                    ? values.periodUom.name
                    : "",
              },
            };
            console.debug("datadatadatadatadatadata", data);
            if (
              data.options.length > 0 &&
              !showDefaultValue &&
              data.default.periodValue === "" &&
              data.default.periodUom === ""
            ) {
              this.props.setFlagForDefault(false);
            } else if (
              (data.options.length > 0 &&
                showDefaultValue &&
                data.default.periodValue === "") ||
              data.default.periodUom === ""
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(false);
            } else if (
              data.options.length > 0 &&
              showDefaultValue &&
              data.default.periodValue !== "" &&
              data.default.periodUom !== ""
            ) {
              this.props.setFlagForDefault(true);
              this.props.metaValidStatus(true);
            }
            this.props.setMetaFieldValues(data);
            return (
              <React.Fragment>
                <span className="revvform-label">
                  Period
                  <span className="requiredwitherr-input">*</span>
                </span>
                <CustomSelect
                  id="options"
                  name="options"
                  value={values.options}
                  getOptionLabel={({ name }) => name}
                  options={PeriodOptions}
                  isMulti
                  _handleChangeInSelect={value =>
                    handleChangeByName(value, "options")
                  }
                  required
                />
                {values.options.length > 0 && (
                  <React.Fragment>
                    <div className="dynamicfieldcustom-default-container">
                      <Input
                        id="checkbox"
                        data-test="PeriodField-checkbox"
                        type="checkbox"
                        checked={showDefaultValue}
                        onChange={() => this._toggleDefaultValue()}
                        className="dynamicfieldcustom-footer-input errorborder"
                      />
                      <span className="dynamicfieldcustom-footer-checkboxinput">
                        This has a default value
                      </span>
                    </div>
                  </React.Fragment>
                )}

                {showDefaultValue && values.options.length > 0 && (
                  <div>
                    <span className="revvform-label">
                      Default value
                      <span className="requiredwitherr-input"> *</span>
                    </span>
                    <Input
                      autoFocus
                      id="periodValue"
                      name="periodValue"
                      data-test="PeriodField-periodValue"
                      type="number"
                      value={values && values.periodValue}
                      placeholder="Enter field default value"
                      className="dynamicfieldcustom-footer-input errorborder"
                      onChange={value => handleChange(value)}
                      // onBlur={value => handleBlur(value)}
                      required
                    />
                    {messages.default && (
                      <ErrorMessages messages={messages.default.required} />
                    )}
                    <span className="revvform-label">
                      Default unit
                      <span className="requiredwitherr-input">*</span>
                    </span>
                    <CustomSelect
                      autoFocus
                      id="periodUom"
                      name="periodUom"
                      value={values.periodUom}
                      getOptionLabel={({ name }) => name}
                      options={values.options}
                      _handleChangeInSelect={value =>
                        handleChangeByName(value, "periodUom")
                      }
                      required
                    />
                  </div>
                )}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
  setFlagForCommonFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PeriodField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/PeriodField.js